import SvgIcon from 'components/Luxkit/SvgIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.seven};
  padding: ${rem(16)};
`

interface Props {
  heading: ReactNode
  description: ReactNode
  action?: ReactNode
  Icon: typeof SvgIcon
}

function AdditionalWaysToExperienceMessagingTile({ heading, description, action, Icon }: Props) {
  return <Container direction="vertical" gap={12} verticalAlign="space-between">
    <Group direction="horizontal" gap={12} horizontalAlign="space-between">
      <Group direction="vertical" gap={8}>
        <BodyText variant="medium" weight="bold">{heading}</BodyText>
        <BodyText variant="small">{description}</BodyText>
      </Group>
      <Icon size="XL" colour="highlight-tertiary" />
    </Group>
    {!!action && <div>{action}</div>}
  </Container>
}

export default AdditionalWaysToExperienceMessagingTile
